module.exports = __webpack_public_path__ + "static/media/case4B.df36c05.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case4B.mp4
// module id = hpRA
// module chunks = 0